export const DELIVERY_ROUTES = {
  ROOT: "delivery",
  SETTINGS: "settings",
  COVERAGE: "coverage",
  CREATE: "create",
  CREATE_WITH_ORDER: "create/:orderId",
  MANUAL_CHECKOUT: "checkout",
  CHECKOUT: ":orderId/checkout",
  DETAIL: ":orderId",
} as const;
